<div class="ribbon-wrap">
    <div class="corner-ribbon" [class.shadow]="shadow" [class.top-right]="topRight">
        <span><ng-content></ng-content></span>
    </div>
</div>
